<template>
  <div>
    <page-header>
      <div class="row ml-3">
        <div class="ml-1">
          <router-link class="ml-4 mt-3 mb-2" :to="{ name: 'Boards' }">
            <div class="badgebutton active text-nowrap c-white">
              <i class="far fa-clock"></i>
              Back to Landing page
            </div>
          </router-link>
        </div>
      </div>
    </page-header>

    <div class="so-overview">
      <SpecialOccurrencesOverview />
    </div>

    <AppInfo />
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import PageHeader from '@/components/PageHeader.vue';
  import SpecialOccurrencesOverview from '@/components/Overview/SpecialOccurrencesOverview.vue';
  import { OverviewModule, OverviewStore } from '@/store/overview';
  import RouteNames from '@/types/routeNames';

  @Component({
    components: {
      PageHeader,
      SpecialOccurrencesOverview,
    },
  })
  export default class OccurrencesOverview extends Vue {
    private store: OverviewModule = OverviewStore;
    private routeNames = RouteNames;

    mounted() {
      this.$router.beforeEach((to, from, next) => {
        if (to.name !== this.routeNames.specialOccurrence.root && to.name !== this.routeNames.specialOccurrence.overview) {
          this.store.setSOFilters(null);
        }
        next();
      });
    }

    beforeDestroy() {
      this.store.setSpecialOccurrencesOverview([]);
    }
  }
</script>

<style lang="scss" scoped>
  .so-overview {
    margin: 1em;
    padding: 1.5rem;
    background-color: rgba(248, 248, 248, 0.9);
    background-blend-mode: difference;
    border-radius: 4px;
  }
</style>
